define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Field",
	"csi/locale",
	"csi/xml",
	"SiteAdmin/DataSheetForm",
	"./ProductBOMFormMixin"
], function(declare, lang, config, Field, locale, xml, DataSheetForm, ProductBOMFormMixin) {

	return declare([DataSheetForm, ProductBOMFormMixin], {
		THEME: "Theme",

		/** @property set to true on NewStyleBOMFromThemeBOMController action as we are making a link with ThemeBOM */
		disableSubtype: false,

		_insertSubtypeField: function() {
			// summary: insert field for "Subtype" and "Theme" if there is any Active ApparelBOMSubtype / Theme
			if (this._hasActiveProductBOMSubtype()) {
				this.insertFieldIfNotExist(this.SUBTYPE, 0, {
					m_onChange: "onChangeBOMSubtype",
				});
			}

			const source = this.defView.getSource();

			if (source?.m_action.m_id == "NewFromTheme") {
				const theme = source.m_cache.getNode(source.getParent().Theme);
				this.insertFieldIfNotExist(this.THEME, 0, {
				});
				this.addFixedValue(this.THEME, theme.$Name);

				if (this._hasActiveProductBOMSubtype()) {
					// pre-populate the subtype to match the theme's bom subtype
					const bomType = theme.ThemeBOMType;
					if (xml.isValidURL(bomType)) {
						this.addFixedValue(this.SUBTYPE, bomType);
					}
				}
			}
		},

		_resolveView: function() {
			this._insertSubtypeField();
			this.setFieldDisabled(this.SUBTYPE, this.disableSubtype);
			this.inherited(arguments);
			const parent = this.defView.getSource().getParent();

			const source = this.defView.getSource();
			let nameField = this.getField(xml.ATTR_NAME);

			const label = source.m_action.m_id == "PromoteStyleBOMToThemeBOM" ? "ThemeBOM" : null;
			if (label !== null) {
				nameField.m_label = locale.resource(label);
			}

			// add BOMProductColors field if our parent is a Style (not a template)
			if (parent.$Type == "Style") {
				this.insertFieldIfNotExist("BOMProductColors", 0, {
					m_path: "Child:CurrentRevision",
				});
			}
			if (parent.$Type == "Theme") {
				this.addDefaultValue(this.SUBTYPE, parent.ThemeBOMType);
				nameField.m_label = locale.resource("ThemeBOM");
			}
		}
	});
});